import { Package } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/components/ui/table'
import { useOrderPackagingDeducted } from '@/hooks/use-sales-order-query'
import { m } from '@/lib/paraglide/messages'

interface Props {
    orderId: string
}

// OrderPackagingDeducted — section trên order detail page. Hiển thị danh sách
// vật tư bao bì đã bị trừ ở bước Confirm, group theo lô. Ẩn card nếu đơn
// chưa Confirm hoặc không có vật tư.
export function OrderPackagingDeducted({ orderId }: Props) {
    const { data: items = [], isLoading } = useOrderPackagingDeducted(orderId)

    if (isLoading || items.length === 0) {
        return null
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Package className="size-5" />{' '}
                    {m.order_packaging_deducted_title()}
                </CardTitle>
                <p className="text-xs text-muted-foreground mt-1">
                    {m.order_packaging_deducted_desc()}
                </p>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>
                                {m.order_packaging_col_material()}
                            </TableHead>
                            <TableHead>{m.order_packaging_col_lot()}</TableHead>
                            <TableHead className="text-right">
                                {m.order_packaging_col_qty()}
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {items.map((it) => (
                            <TableRow
                                key={`${it.packaging_material_id}-${it.packaging_lot_id}`}
                            >
                                <TableCell>
                                    <div className="font-medium">
                                        {it.material_name}
                                    </div>
                                    <div className="text-xs text-muted-foreground font-mono">
                                        {it.material_sku} · {it.material_unit}
                                    </div>
                                </TableCell>
                                <TableCell className="font-mono text-sm">
                                    {it.lot_code}
                                </TableCell>
                                <TableCell className="text-right tabular-nums font-semibold">
                                    {it.deducted_qty}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    )
}
